import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { ContentPageModerationClassification } from "views/knowledge/components/card/behaviors/common/ContentPageModerationClassification";
import { useCardContext } from "../../CardBuilder";

///
export const ContentPageClassification = () => {
    const { pub } = useCardContext();

    if (pub.approvalStatus != PublicationApprovalStatus.Approved) {
        return <ContentPageModerationClassification />;
    }

    return null;
};
